// extracted by mini-css-extract-plugin
export var container = "OurMission-module--container--NHCUM";
export var firstGroup = "OurMission-module--first-group--P4LyX";
export var img = "OurMission-module--img--3RDaH";
export var link = "OurMission-module--link--em+qL";
export var paragraph = "OurMission-module--paragraph--IdpqV";
export var secondGroup = "OurMission-module--second-group--9g677";
export var secondParagraph = "OurMission-module--second-paragraph--7eEDA";
export var video = "OurMission-module--video--GamZy";